export default __webpack_public_path__ + "img/header-d662208e.png";